/**
 * @file: runAfterInteraction.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { InteractionManager, Platform } from 'react-native';

export const runAfterInteractions = (task?: () => any) => {
  if (Platform.OS === 'web') {
    void task?.();
  } else {
    void InteractionManager.runAfterInteractions(task);
  }
};
